import { createIcon, Path } from './index';

export const IconBriefcase = createIcon({
  title: 'A briefcase',
  viewBox: '0 0 32 32',
  path: [
    <Path
      d="M26.667 9.33331H5.33366C3.8609 9.33331 2.66699 10.5272 2.66699 12V25.3333C2.66699 26.8061 3.8609 28 5.33366 28H26.667C28.1398 28 29.3337 26.8061 29.3337 25.3333V12C29.3337 10.5272 28.1398 9.33331 26.667 9.33331Z"
      fill="none"
      stroke="#35405F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <Path
      d="M21.3337 28V6.66667C21.3337 5.95942 21.0527 5.28115 20.5526 4.78105C20.0525 4.28095 19.3742 4 18.667 4H13.3337C12.6264 4 11.9481 4.28095 11.448 4.78105C10.9479 5.28115 10.667 5.95942 10.667 6.66667V28"
      fill="none"
      stroke="#35405F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});
